import React from "react";
import "./dashboardcards.css";
import { Col, Row } from "antd";

const DashboardCards = ({ cardType, setCardType, data }) => {
  return (
    <>
      <div
        className="cards"
        style={{
          boxShadow: `${cardType === data.type ? "10px 5px 20px #707070" : ""}`,
        }}
        onClick={(e) => setCardType(data.type)}
        aria-hidden="true"
      >
        <Row>
          <Col span={24}>
            <div className="data-type">{data.label}</div>
          </Col>
        </Row>
        <Row>
          <Col span={8}>
            <div className="cards-data-total cards-circle">
              <div className="cards-data-title">{data.total}</div>
              <div className="cards-data-total-text">Total</div>
            </div>
          </Col>
          <Col span={8}>
            <div className="cards-data-approved cards-circle">
              <div className="cards-data-title">{data.approved}</div>
              <div className="cards-data-total-text">Approved</div>
            </div>
          </Col>
          <Col span={8}>
            <div className="cards-data-pending cards-circle">
              <div className="cards-data-title">{data.pending}</div>
              <div className="cards-data-total-text">Pending</div>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default DashboardCards;
